import React, {useEffect, useState} from 'react';
import ShowTabsList from "../../../common/ui/show-tabs-list";
import {
    DEFAULT_SHOPIFY_DASHBOARD_TAB,
    SHOPIFY_DASHBOARD_TABS_LIST,
    SHOPIFY_KEYS
} from "../../constants/shopify.constant";
import ShopifyProductList from "../product/shopify-product-list";
import ShopifyBulkOperationList from "../bulk-operation/shopify-bulk-operation-list";
import InstagramShopifyProductList from "../product/instagram-shopify-product-list";
import ShopifyBulkProductUpdateList from "../bulk-product-update/shopify-bulk-product-update-list";
import ShopifyBlogList from "../blogs/shopify-blog-list";
import ShopifyCollectionList from "../collections/shopify-collection-list";
import PrintfulProductsPriceList
    from "../../../printful/components/printful-products-price/printful-products-price-list";
import ShopifyProductPriceSyncsList from "../shopify-product-price-sync/shopify-product-price-sync-list";
import SelectedProductList from "../../../marketing/components/products/selected-product-list";
import MediaList from "../../../marketing/components/media/media-list";
import DesignInfoList from "../design-info/design-info-list";
import _ from "lodash";
import {getDataFromLocalStorage, setDataInLocalStorage} from "../../../common/utils/local-storage-util";
import {DESIGN_INFO_KEYS} from "../../constants/design-info.constant";
import DesignSyncList from "../design-sync/design-sync-list";
import DesignBlogPostList from "../design-blog-post/design-blog-post-list";
import PinterestPinSyncList from "../../../pinterest/components/pinterest-pin-sync/pinterest-pin-sync-list";

const tabsList = SHOPIFY_DASHBOARD_TABS_LIST;

const ShopifyDashboard = () => {
    const [initialStep, setInitialStep] = useState(true);
    const [selectedTab, setSelectedTab] = useState(DEFAULT_SHOPIFY_DASHBOARD_TAB);

    useEffect(() => {
        if (initialStep) {
            init();
            setInitialStep(false);
        }
    }, [initialStep]);

    const init = () => {
        const existingSelectedTab = getDataFromLocalStorage(SHOPIFY_KEYS.SELECTED_TAB);

        if (existingSelectedTab) {
            setSelectedTab(existingSelectedTab);
        }
    }

    useEffect(() => {
        if (!_.isEmpty(selectedTab)) {
            setDataInLocalStorage(SHOPIFY_KEYS.SELECTED_TAB, selectedTab);
        }
    }, [selectedTab]);

    return (
        <>

            <div className="page-container">

                <div className="items-center justify-start p-4 w-full">
                    <div className="flex justify-start items-center m-2 pb-2">
                        <div className="text-xl mr-4">
                            Shopify
                        </div>

                        <div className={''}>
                            <ShowTabsList
                                setSelectedTab={setSelectedTab}
                                selectedTab={selectedTab}
                                tabsList={tabsList}/>
                        </div>
                    </div>


                    <div className="justify-center">

                        <div className="justify-start pt-2 pb-4">

                            {!initialStep &&

                                <div className="px-4">

                                    {selectedTab?.key === 'products' &&
                                        <div>
                                            <ShopifyProductList/>
                                        </div>
                                    }

                                    {selectedTab?.key === 'designs' &&
                                        <div>
                                            <DesignInfoList/>
                                        </div>
                                    }

                                    {selectedTab?.key === 'design-sync' &&
                                        <div>
                                            <DesignSyncList/>
                                        </div>
                                    }

                                    {selectedTab?.key === 'pinterest-pin-sync' &&
                                        <div>
                                            <PinterestPinSyncList/>
                                        </div>
                                    }

                                    {selectedTab?.key === 'instagram' &&
                                        <div>
                                            <InstagramShopifyProductList/>
                                        </div>
                                    }

                                    {selectedTab?.key === 'bulkOperations' &&
                                        <div>
                                            <ShopifyBulkOperationList/>
                                        </div>
                                    }

                                    {selectedTab?.key === 'bulkProductUpdates' &&
                                        <div>
                                            <ShopifyBulkProductUpdateList/>
                                        </div>
                                    }

                                    {selectedTab?.key === 'collections' &&
                                        <div>
                                            <ShopifyCollectionList/>
                                        </div>
                                    }

                                    {selectedTab?.key === 'blogs' &&
                                        <div>
                                            <ShopifyBlogList/>
                                        </div>
                                    }

                                    {selectedTab?.key === 'blog-posts' &&
                                        <div>
                                            <DesignBlogPostList/>
                                        </div>
                                    }

                                    {selectedTab?.key === 'productsPrice' &&
                                        <div>
                                            <PrintfulProductsPriceList/>
                                        </div>
                                    }

                                    {selectedTab?.key === 'productsPriceSync' &&
                                        <div>
                                            <ShopifyProductPriceSyncsList/>
                                        </div>
                                    }

                                    {selectedTab?.key === 'selected-products' &&
                                        <div>
                                            <SelectedProductList/>
                                        </div>
                                    }

                                    {selectedTab?.key === 'media' &&
                                        <div>
                                            <MediaList/>
                                        </div>
                                    }

                                </div>

                            }

                        </div>

                    </div>

                </div>

            </div>

        </>
    )
}

export default ShopifyDashboard
